import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

function DateTimeColumnRenderer(props) {
  const { dateTime, displayFormat, displayTimezone } = props;
  if (!dateTime) {
    return (<Fragment />);
  }

  const tz = moment.tz(dateTime, displayTimezone);
  return (
    <div data-label={props.intl.formatMessage({ id: 'Grid.Column.VisitStartTimestamp' })}>
      {dateTime && moment(tz).format(displayFormat)}
    </div>
  );
}

DateTimeColumnRenderer.propTypes = {
  dateTime: PropTypes.string,
  displayFormat: PropTypes.string.isRequired,
  displayTimezone: PropTypes.string.isRequired,
};

export default injectIntl(DateTimeColumnRenderer);



// WEBPACK FOOTER //
// ./src/components/common/Table/DateTimeColumnRenderer.js